import React, { Fragment } from 'react';
import { useState } from 'react';
import { Button, Icon, Modal } from 'antd';
import { Link } from 'react-router-dom';

import Coins from '../../components/Coins';
import RemoveConfirmation from '../CreateExchange/Confirmation';
import PairContainer from './style';

const Preview = ({
    isExchangeWizard,
    coins = [],
    isPreview = false,
    isConfigure = false,
    formData = {},
    moveToStep,
    handleNext,
    onEdit,
    onDelete,
    renderStatus = () => { },
    isEdit,
    allCoins,
    user,
    prevStep
}) => {
    const pair_base_data = allCoins.filter((data) => data.symbol === formData.pair_base)[0] || {};
    const pair2_data = allCoins.filter((data) => data.symbol === formData.pair_2)[0] || {};
    const [isVisible, setIsVisible] = useState(false);

    return (
        <div>
            {!isPreview && !isConfigure
                ? (
                    <Fragment>
                        <div className="title">Review & confirm market</div>
                        <div className="grey-warning">
                            <div className="warning-text">!</div>
                            <div>
                                <div className="sub-title">Please check the details carefully.</div>
                                <div className="description">To avoid delays it is important to take the time to review the accuracy of the details below</div>
                            </div>
                        </div>
                    </Fragment>
                )
                : null
            }
            <div
                className={
                    !isPreview && !isConfigure
                        ? "d-flex preview-container"
                        : "preview-container"
                }
            >
                <div
                    className={
                        !isPreview && !isConfigure
                            ? "d-flex flex-container left-container"
                            : "d-flex flex-container left-container-preview"
                    }
                >
                    <div>
                        <Coins
                            nohover
                            color={
                                pair_base_data.meta
                                    ? pair_base_data.meta.color
                                    : ''
                            }
                            large
                            small
                            fullname={pair_base_data.fullname}
                            type={(formData.pair_base || '').toLowerCase()}
                        />
                        <div className="status-wrapper">
                            {isPreview && !pair_base_data.verified
                                ?
                                <div className="exclamation-icon">
                                    <Icon type="exclamation-circle" theme="filled" />
                                </div>
                                : null
                            }
                            {isConfigure
                                ? renderStatus(pair_base_data, user)
                                : null
                            }
                        </div>
                        {isPreview || isConfigure
                            ?
                            <div className='sub-txt'>
                                (<Link to={`/financial?preview=true&symbol=${formData.pair_base}`} className='sub-txt'>
                                    View details
                                </Link>)
                            </div>
                            : null
                        }
                    </div>
                    <div className="cross-text">X</div>
                    <div>
                        <Coins
                            nohover
                            color={
                                pair2_data.meta
                                    ? pair2_data.meta.color
                                    : ''
                            }
                            large
                            small
                            fullname={pair2_data.fullname}
                            type={(formData.pair_2 || '').toLowerCase()}
                        />
                        <div className="status-wrapper">
                            {isPreview && !pair2_data.verified
                                ?
                                <div className="exclamation-icon">
                                    <Icon type="exclamation-circle" theme="filled" />
                                </div>
                                : null
                            }
                            {isConfigure
                                ? renderStatus(pair2_data, user)
                                : null
                            }
                        </div>
                        {isConfigure || isPreview
                            ?
                            <div className='sub-txt'>
                                (<Link to={`/financial?preview=true&symbol=${formData.pair_2}`} className='sub-txt'>
                                    View details
                                </Link>)
                            </div>
                            : null
                        }
                    </div>
                </div>
                <div className={!isPreview && !isConfigure ? "right-container" : ""}>
                    <div className="right-content">
                        <div className="title">Market info</div>
                        <div className='sub-title'>Base market: <span className='sub-txt'>{formData.pair_base}</span></div>
                        <div className='sub-title'>Price market: <span className='sub-txt'>{formData.pair_2}</span></div>
                    </div>
                    <div className="right-content">
                        <div className="title">Parameters</div>
                        {isConfigure
                            ? <div className='sub-title'>Name: <span className='sub-txt'>{formData.name}</span></div>
                            : null
                        }
                        <div className='sub-title'>Status: <span className='sub-txt'>{formData.active ? 'active' : 'Inactive'}</span></div>
                        <div className='sub-title'>Estimated price: <span className='sub-txt'>{formData.estimated_price}</span></div>
                        <div className='sub-title'>Increment price: <span className='sub-txt'>{formData.increment_price}</span></div>
                        <div className='sub-title'>Increment size: <span className='sub-txt'>{formData.increment_size}</span></div>
                        <div className='sub-title'>Max price: <span className='sub-txt'>{formData.max_price}</span></div>
                        <div className='sub-title'>Max size: <span className='sub-txt'>{formData.max_size}</span></div>
                        <div className='sub-title'>Min price: <span className='sub-txt'>{formData.min_price}</span></div>
                        <div className='sub-title'>Min size: <span className='sub-txt'>{formData.min_size}</span></div>
                        {isConfigure
                            ? <div><Button type="primary" onClick={onEdit}>Edit</Button></div>
                            : null
                        }
                    </div>
                    {isPreview || isConfigure
                        ? <div className="right-content">
                            <div className="title">Manage</div>
                            <div className="d-flex flex-container">
                                <div className="btn-wrapper">
                                    {/* <Button type="danger" onClick={() => onDelete(formData)}>Remove</Button> */}
                                    <Button type="danger" onClick={() => setIsVisible(true)}>Remove</Button>
                                    <div className="separator"></div>
                                    <div className="description-small remove">Removing this market will permanently delete this market from your exchange. Use with caution!</div>
                                </div>
                            </div>
                        </div>
                        : null
                    }
                </div>
            </div>
            {!isPreview && !isConfigure
                ? (
                    <div className="btn-wrapper">
                        <Button
                            type="primary"
                            onClick={() => {
                                if ((formData.id && !isExchangeWizard) || prevStep === 'step1') {
                                    moveToStep('step1')
                                } else if (prevStep === 'step2') {
                                    moveToStep('step2')
                                } else {
                                    moveToStep('pair-init-selection')
                                }
                            }}
                        >
                            Back
                        </Button>
                        <div className="separator"></div>
                        <Button type="primary" onClick={() => handleNext(formData)}>
                            Next
                        </Button>
                    </div>
                )
                : null
            }
            {isVisible ? <Modal visible={isVisible} footer={null} onCancel={() => setIsVisible(false)}>
                <PairContainer>
                    <RemoveConfirmation
                        onCancel={setIsVisible}
                        onHandleRemoveMarket={onDelete}
                        removePair={formData}
                        removeContent={'Markets'}
                    />
                </PairContainer>
            </Modal> : null}
        </div>
    )
}

export default Preview;
